/**
 * Created by ianandersen on 4/5/17.
 */

import React from 'react';

class Subtitle extends React.Component{
  constructor(props){
    super(props);
    this.text = props.text;
  }

  render(){
    return <h3 style={{fontStyle: 'italic', marginTop: '2px'}}>{this.text}</h3>;
  }
}

export default Subtitle;
